// AuthContext.js - FIXED VERSION
import React, { createContext, useContext, useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

export const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null); // Add token state

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    const userRole = localStorage.getItem("userRole");
    const userId = localStorage.getItem("userId");
    const userName = localStorage.getItem("userName");

    if (storedToken && userRole && userId) {
      setToken(storedToken); // Set token state
      setIsAuthenticated(true);
      setUser({
        id: userId,
        name: userName,
        role: userRole,
      });
    } else {
      // If incomplete data, clear everything
      clearAllUserData();
    }
    setIsLoading(false);
  }, []);

  const clearAllUserData = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userRole");
    localStorage.removeItem("userId");
    localStorage.removeItem("userName");
    setUser(null);
    setToken(null); // Clear token state
  };

  const login = (authToken, userData = null) => {
    localStorage.setItem("token", authToken);
    setToken(authToken); // Set token state

    if (userData) {
      localStorage.setItem("userRole", userData.role || "employee");
      localStorage.setItem("userId", userData._id || userData.id || "");
      localStorage.setItem("userName", userData.name || "User");

      setUser({
        id: userData._id || userData.id,
        name: userData.name,
        role: userData.role,
      });
    }

    setIsAuthenticated(true);
  };

  const logout = () => {
    clearAllUserData();
    setIsAuthenticated(false);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        token, // Now properly defined
        isLoading,
        user,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};
